import { ChangeDetectionStrategy, Component, OnInit, computed, inject, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter } from 'rxjs';

import { AuthState, LoadMyVerification, MyVerificationState } from '@data/state';
import { ApplicationRoleType } from '@data/enum';
import { VerificationStatus } from '@data/schema';

@Component({
    selector: 'app-verification-nudge-banner',
    standalone: true,
    imports: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (visible()) {
            <div class="verification-nudge">
                <span class="mdi mdi-check-decagram-outline" aria-hidden="true"></span>
                <span class="verification-nudge__text">
                    Get your Verified Supplier badge — confirm your business identity and trade licence.
                </span>
                <a routerLink="/verification" class="verification-nudge__cta">Get verified</a>
            </div>
        }
    `,
})
export class VerificationNudgeBannerComponent implements OnInit {
    private readonly _store = inject(Store);
    private readonly _router = inject(Router);

    private readonly _roleType = this._store.selectSignal(AuthState.roleType);
    private readonly _status = this._store.selectSignal(MyVerificationState.status);

    readonly onVerificationPage = signal(this._router.url.startsWith('/verification'));

    readonly visible = computed(
        () =>
            this._roleType() === ApplicationRoleType.DISTRIBUTOR_SUPPLIER &&
            this._status()?.status === VerificationStatus.UNSUBMITTED &&
            !this.onVerificationPage(),
    );

    ngOnInit(): void {
        if (this._roleType() === ApplicationRoleType.DISTRIBUTOR_SUPPLIER) {
            this._store.dispatch(new LoadMyVerification());
        }
        this._router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e) => {
            this.onVerificationPage.set((e as NavigationEnd).urlAfterRedirects.startsWith('/verification'));
        });
    }
}
